import Conversion from './../models/Conversion';
import Base from './Base';

export default class Conversions extends Base {
    get models() {
        const collection = this.data.map(item => new Conversion(item));
        collection.collection = this;

        return collection;
    }
}
